/**
 * Extracts the download filename from a Content-Disposition header value,
 * supporting plain, quoted, and RFC 5987 (filename*=UTF-8'') forms. Returns
 * null when no filename can be found.
 */
export const getFilenameFromContentDisposition = (
    disposition: string | undefined | null,
): string | null => {
    if (!disposition) return null;

    const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
    if (!match) return null;

    return decodeURIComponent(match[1].trim());
};
